import * as React from 'react';

export interface PublicFundsIconProps {
  className?: string;
  size?: number;
  title?: string;
}

/**
 * PublicFundsIcon — PCB Retail Modal entity icon (v2.5)
 *
 * @description Public Funds (government treasury). Capitol building with gold $ disc above dome.
 */
const PublicFundsIcon: React.FunctionComponent<PublicFundsIconProps> = ({
  className,
  size = 40,
  title = 'Public Funds',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
      <rect x="10" y="20" width="28" height="20" fill="#3B6D11"/>
      <rect x="13" y="24" width="3" height="14" fill="#C0DD97"/>
      <rect x="18" y="24" width="3" height="14" fill="#C0DD97"/>
      <rect x="23" y="24" width="3" height="14" fill="#C0DD97"/>
      <rect x="28" y="24" width="3" height="14" fill="#C0DD97"/>
      <rect x="33" y="24" width="3" height="14" fill="#C0DD97"/>
      <path d="M8 20 L24 12 L40 20 Z" fill="#27500A"/>
      <rect x="9" y="40" width="30" height="2" fill="#27500A"/>
      <circle cx="24" cy="8" r="4" fill="#d4a958" stroke="#8a6a2c" strokeWidth="0.8"/>
      <text x="24" y="10" textAnchor="middle" fontFamily="serif" fontSize="6" fontWeight="900" fill="#27500A">$</text>
  </svg>
);

export default PublicFundsIcon;
